import 'dayjs/locale/en'; // 영어 로케일을 사용합니다.

import React from 'react';

import DeleteRedIcon from 'assets/images/icon/DeleteRedIcon';
import EditIcon from 'assets/images/icon/EditIcon';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';
import { textTransform } from 'util/textTransform';
import { CheckBox } from 'view/components/common/CheckBox';

interface StyledComponentProps {
    width?: string;
}

const ListItem = (props) => {
    const { 
        id,
        firstName, lastName, createdDatetime, updatedDatetime, email, jobTitle, joinStatus  } =
        props?.data;

    const returnData = (date) => {
        // const c = cloneDeep(date).map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    return (
        <Container>
            <Col width={"20px"}>
                <div style={{ paddingTop: 1 }}>
                    <CheckBox 
                    state={props?.idList?.findIndex(findItem => findItem === id) !== -1}
                    onClick={()=>{props.onClickAddIndex(id)}} />
                </div>
            </Col>
            <Col width={"70px"}>
                <span style={{ fontSize: 13, lineHeight: 1.2 }}>
                    {firstName} {lastName}
                </span>
            </Col>
            <Col width={"90px"}>
                <span>{`${firstName}_${lastName}`}</span>
            </Col>
            <Col width={"70px"}>
                <span>
                    {jobTitle}
                </span>
               
            </Col>
            <Col width={"130px"} style={{}}>
                <input
                    type="text"
                    style={{ width: 130, fontSize: 12 }}
                    value={email}
                    readOnly={true}
                />
            </Col>

            <Col width={"70px"}>
                <span>
                    {textTransform().capitalizeFirstLetter(String(joinStatus)?.toLocaleLowerCase())}
                </span>
            </Col>
            <Col width={"90px"}>
                <span>{returnData(createdDatetime)}</span>
            </Col>
            <Col width={"80px"}>
                <span>{returnData(updatedDatetime)}</span>
            </Col>
            <Col width={"70px"}>
                <Icons>
                    <Icon 
                    onClick={()=>{
                        props?.onClickDelete(id)
                    }}
                    style={{ marginRight: "50%" }}>
                        <DeleteRedIcon />
                    </Icon>
                    <Icon                        
                        onClick={()=>{
                            props?.onClickEdit(id)
                        }}
                    >
                        <EditIcon />
                    </Icon>
                </Icons>
            </Col>
        </Container>
    );
};
export default ListItem;

const Container = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    height: 68px;
    border-bottom: solid 1px #e9edf5;
    /* overflow-x: scroll; */
    padding: 0 20px;
    /* width: 100%; */
`;

const Col = styled.div<StyledComponentProps>`
    display: flex;
    align-items: center;
    word-wrap: break-word;
    width: ${(props) => (props.width ? `${props.width}` : "auto")};
    min-width: ${(props) => (props.width ? `${props.width}` : "auto")};
    flex-wrap: wrap;
    /* min-width: ${(props) => (props.width ? `calc(${props.width} / 100%)` : "auto")}; */
    margin: 0 10px;
    justify-content: flex-start;
    &:nth-child(1) {
        margin-left: 0;
        margin-right: 0.5%;
    }
    &:last-child {
        margin-right: 0;
    }
    span {
        padding-top: 1px;
        font-size: 14px;
        color: #333333d5;
    }
    input {
        display: flex;
        height: 30px;
        font-size: 14px;
        color: #333333d5;
        border: solid 1px #ddd;
        border-radius: 4px;
        padding: 4px;
    }
`;

const Icons = styled.div`
    display: flex;
    align-items: center;
`;
const Icon = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
`;
